import React from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { showLog } from '@libs/NwMoment';

import { useUserPermission } from '@contexts/UserContext';

import { forceReloadCreditNote } from '@hooks/API/UseCreditNotes';
import { forceReloadInvoice } from '@hooks/API/UseInvoices';

import { NwButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    padding: 1rem 0 2rem 0;
    .top-message {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        padding: 0.5rem 2rem;
        background: ${(props) => props.theme.SelectedBackgroundColor};
        border: ${(props) => props.theme.DefaultBorder};
        border-radius: 0.5rem;

        .top-message-left {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 1rem;

            .top-message-icon {
                font-size: 1.5em;
                padding-right: 1rem;
                border-right: ${(props) => props.theme.DefaultBorder};
            }
            .top-message-text {
                font-size: 1em;
                font-weight: bold;
            }
        }
        .top-message-button {
        }

        &.warning {
            .top-message-left {
                .top-message-icon {
                    --fa-primary-color: ${(props) => props.theme.DangerColor};
                    --fa-secondary-color: ${(props) => props.theme.WarningColor};
                    --fa-primary-opacity: 1;
                    --fa-secondary-opacity: 1;
                }
            }
        }
        &.success {
            .top-message-left {
                .top-message-icon {
                    --fa-primary-color: ${(props) => props.theme.SuccessColor};
                    --fa-secondary-color: ${(props) => props.theme.SuccessColorLight};
                    --fa-primary-opacity: 1;
                    --fa-secondary-opacity: 1;
                }
            }
        }
    }
`;

const SentStatus = ({ data }) => {
    const isCreditNote = data.TypeName.includes('Credit');

    const setAsNotReadyToPost = async () => {
        if (!isCreditNote) {
            await Axios.put(`/Invoices/SetReadyToPost`, { InvoiceID: data.ID, ReadyToPost: false });
            forceReloadInvoice(data.ID);
        } else {
            await Axios.put(`/CreditNotes/SetReadyToPost`, { CreditNoteID: data.ID, ReadyToPost: false });
            forceReloadCreditNote(data.ID);
        }
    };

    const canPost = useUserPermission('PostInvoice');

    const typeName = isCreditNote ? 'credit note' : 'invoice';

    return (
        <Wrapper>
            {data.Posted ? (
                <div className="top-message success">
                    <div className="top-message-left">
                        <div className="top-message-icon">
                            <NwIcon icon={byPrefixAndName.fasds['file-export']} />
                        </div>
                        <div className="top-message-text">
                            This {typeName} has been sent on {showLog(data.PostedDate)}
                        </div>
                    </div>
                </div>
            ) : data.ReadyToPost ? (
                <div className="top-message warning">
                    <div className="top-message-left">
                        <div className="top-message-icon">
                            <NwIcon icon={byPrefixAndName.fasds['file-lock']} />
                        </div>
                        <div className="top-message-text">This {typeName} is ready to be sent and can't be updated</div>
                    </div>
                    {canPost && (
                        <div className="top-message-button">
                            <NwButton type="primary" onClick={setAsNotReadyToPost} label="Unlock" />
                        </div>
                    )}
                </div>
            ) : (
                <></>
            )}
        </Wrapper>
    );
};

export default SentStatus;
